import type { IHiddenColumnsMigration } from '../../ui/data-table/hidden-columns-migration';

/**
 * Responsibility and Responsibility Category are visible by default on the claims tables of both consoles
 * (2026-10-09) — what the widget above the table selects is what these two columns show. Both apps use these
 * column ids.
 *
 * Making a column visible in its definition does not reach anyone with saved column settings (the presenter
 * prefers them), so each claims table applies this once before its presenter is built. Once applied it is
 * recorded, and a user who hides either column again keeps it hidden.
 */
export const RESPONSIBILITY_COLUMNS_MIGRATION: IHiddenColumnsMigration = {
    id: 'responsibility-columns-visible',
    columnIds: ['Responsibility', 'ResponsibilityCategory'],
    action: 'show',
};
